import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Popup,
  Modal,
  //Button,
} from "semantic-ui-react";
import{ imageDomain,singleImageURL} from "../configC/keys"
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { RiImageAddLine } from "react-icons/ri";
import Confirm from "../common/Confirm_1";
import { searchPropOverviews } from "../../actions/propOverviewAction";

import PropOverviewEdit from "../create/PropOverviewEdit";
import AddImageSingle from "../imageUpload/AddImageSingle";

const WhatWeDealsIn = (props) => {
  const [state, setState] = useState({
    play: true,
    stop: false,
    open: false,
    editModalOpen: false,
    imgModalOpen: false,
    path:'',
  });

  // *** show play or stop button of slider control
  const activePlay = () => {
    setState({ ...state, play: true, stop: false });
  };
  // *** show play or stop button of slider control
  const activeStop = () => {
    setState({ ...state, play: false, stop: true });
  };

  const refresh = () => {
    props.searchPropOverviews();
    // window.scroll(0, 0);
  };
  const show = (id,path) => {
    setState({ ...state, open: true, id: id, path:path });
  };

  //******************* */
  const handleConfirm = async () => {
    const did = state.id;
const path = state.path
    const imageURL = singleImageURL;
    //************
    try {
      // ^^^^^^^^^^
      const resImage = await axios.post(`${imageURL}/DeleteImage`, {path});
      //^^^^^^^^^^^^^^^^^
      if (resImage.data.msg === "success") {
        const res = await axios.put(`/api/PropOverviewDelete/${did}`);
        if (res.data.msg === "success") {
          refresh();
          setState({ ...state, open: false });
          toastr.success("Deleted Successfully");
        }
    };
  
    } catch (error) {
      if (error && error.response && error.response.status == 401) {
        this.props.openModal("LoginModal");
        toastr.error(`${JSON.stringify(error.response.data)}`);
      } else if (error) {
        console.log('error_deletePropOverview',error)
        toastr.error(
          "Oops",
          "Something went wrong.Please Try Again_deletePropOverview"
        );
      }
    }
    //**********
  };

  const handleCancel = () => setState({ ...state, open: false });
  //**********************************
  const handleEditModalOpen = (id) =>
    setState({ ...state, editModalOpen: true, id: id });
  const handleEditModalClose = () => {
    setState({ ...state, editModalOpen: false });
  }; //
  const handleEditModalCloseSubmit = () => {
    refresh();
    setState({ ...state, editModalOpen: false });
  };
  //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

  const handleImgModalOpen = (id, img) =>
    setState({ ...state, imgModalOpen: true, id: id, path: img });
  const handleImgModalClose = () => {
    setState({ ...state, imgModalOpen: false });
  }; //
  const handleImgModalCloseSubmit = () => {
    refresh();
    setState({ ...state, imgModalOpen: false });
  };
  const renderPopupState = () => {
    if (window.innerWidth < 600) {
      return true;
    }
    if (window.innerWidth > 600) {
      return false;
    }
  };

  // ******
  const settings = {
    autoplay: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 700,
    // initialSlide: 0,
    arrows: false,
    responsive: [
      // {
      //   breakpoint: 1024,
      //   settings: {
      //     slidesToShow: 3,
      //     slidesToScroll: 1,
      //     infinite: true,
      //     dots: true
      //   }
      // },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          // initialSlide: 2
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  let sliderRef = useRef(null);

  const next = () => {
    sliderRef.slickNext();
  };
  const previous = () => {
    sliderRef.slickPrev();
  };
  const play = () => {
    sliderRef.slickPlay();
    activePlay();
  };
  const pause = () => {
    sliderRef.slickPause();
    activeStop();
  };
  //*************** */

  const renderPlayStopButton = () => {
    if (state.play) {
      return (
        <Popup
          content={"Stop"}
          disabled={renderPopupState()}
          trigger={
            <span className="icon-button-gr" onClick={pause}>
              <img
                src="/stop.png"
                alt=" "
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "5px",
                  verticalAlign: "middle",
                }}
              />
            </span>
          }
        />
      );
    }
    if (state.stop) {
      return (
        <Popup
          content={"Play"}
          disabled={renderPopupState()}
          trigger={
            <span className="icon-button-gr" onClick={play}>
              <img
                src="/play.png"
                alt=" "
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "5px",
                  verticalAlign: "middle",
                }}
              />
            </span>
          }
        />
      );
    }
  };

  //^^^^^^^^^^
  //*************** */
  const renderList = (overviews) => {
    const {
      heading,
      line1,
      line2,
      line3,
      line4,
      line5,
      line6,
      line7,
      tag,
      img,
      _id,
    } = overviews;

    //******************
    const renderDeleteButton = () => (
      <Popup
        content={"Delete"}
        disabled={renderPopupState()}
        trigger={
          <span onClick={() => show(_id,img)} className="">
            <RiDeleteBin5Line
              className="icon-gr"
              style={{ backgroundColor: "red" }}
            />
          </span>
        }
      />
    );
    //^^^^^^^^^^^
    const renderEditButton = () => (
      <Popup
        content={"Edit"}
        disabled={renderPopupState()}
        trigger={
          <span onClick={() => handleEditModalOpen(_id)} className="">
            <FaRegEdit
              className="icon-gr"
              style={{ backgroundColor: "dodgerblue" }}
            />
          </span>
        }
      />
    );

    const renderAddImageButton = () => (
      <Popup
        content={"Add Image"}
        disabled={renderPopupState()}
        trigger={
          <span onClick={() => handleImgModalOpen(_id, img)} className="">
            <RiImageAddLine
              className="icon-gr"
              style={{ backgroundColor: "skyblue" }}
            />
          </span>
        }
      />
    );
    //******************
    return (
      // <div key={_id}>

      <div key={_id} className="card-overview bgColor-gr1 direction-c">
        <div className="content-ov-container">
          <div className="content-ov">
            <span className="ribbon-ov">{tag}</span>
            <div className="heading">{heading} </div>
            {line1 && (
              <div className="list">
                <span className="list-ov">
                  <img
                    src="/bulletIcon_2.png"
                    alt=" "
                    style={{ width: "", height: "", verticalAlign: "" }}
                  />
                </span>
                <span>{line1}</span>
              </div>
            )}
            {line2 && (
              <div className="list">
                <span className="list-ov">
                  <img
                    src="/bulletIcon_2.png"
                    alt=" "
                    style={{ width: "", height: "", verticalAlign: "" }}
                  />
                </span>
                <span>{line2}</span>
              </div>
            )}
            {line3 && (
              <div className="list">
                <span className="list-ov">
                  <img
                    src="/bulletIcon_2.png"
                    alt=" "
                    style={{ width: "", height: "", verticalAlign: "" }}
                  />
                </span>
                <span>{line3}</span>
              </div>
            )}
            {line4 && (
              <div className="list">
                <span className="list-ov">
                  <img
                    src="/bulletIcon_2.png"
                    alt=" "
                    style={{ width: "", height: "", verticalAlign: "" }}
                  />
                </span>
                <span>{line4}</span>
              </div>
            )}
            {line5 && (
              <div className="list">
                <span className="list-ov">
                  <img
                    src="/bulletIcon_2.png"
                    alt=" "
                    style={{ width: "", height: "", verticalAlign: "" }}
                  />
                </span>
                <span>{line5}</span>
              </div>
            )}
            {line6 && (
              <div className="list">
                <span className="list-ov">
                  <img
                    src="/bulletIcon_2.png"
                    alt=" "
                    style={{ width: "", height: "", verticalAlign: "" }}
                  />
                </span>
                <span>{line6}</span>
              </div>
            )}
            {line7 && (
              <div className="list">
                <span className="list-ov">
                  <img
                    src="/bulletIcon_2.png"
                    alt=" "
                    style={{ width: "", height: "", verticalAlign: "" }}
                  />
                </span>
                <span>{line7}</span>
              </div>
            )}
          </div>
        </div>
        {/* img */}
        <div className="img-ov-container">
          <img className="img-ov" src={`${imageDomain}${img}`} />
          <div
            className="mt-10 mb-10"
            style={{ position: "absolute", left: "30%", bottom: "15px" }}
          >
           
            {props.userA !== null &&
                  (props.userA.userType === 'admin' || props.userA.userType === 'manager_dwk' || props.userA.userType === 'manager_ggn') &&
              renderEditButton()}
            {props.userA !== null &&
                  (props.userA.userType === 'admin' || props.userA.userType === 'manager_dwk' || props.userA.userType === 'manager_ggn') &&
              renderDeleteButton()}
            {props.userA !== null &&
                  (props.userA.userType === 'admin' || props.userA.userType === 'manager_dwk' || props.userA.userType === 'manager_ggn') &&
              renderAddImageButton()}
          </div>
        </div>
      </div>
      // </div>
    );
  };

  //*************** */
  return (
    <section className="padding-gr-outer bgColor-gr ">
      <div className="inner-gr bgColor-gr">
        <div className="headtitl">
          <div className="line-height-gr font-36B color-CornflowerBlue px-20">
            What We <span>Deals In</span>
          </div>
          <div className="font-18B px-20 ">
            <p>
              We have over 30 years of experience and knowledge on various real
              state business transactions.
            </p>
          </div>
          <div className="devider"></div>
        </div>

        {/*  */}
        <div
          style={{ margin: "auto", maxWidth: "1140px" }}
          className="slider-container"
        >
          <Slider
            ref={(slider) => {
              sliderRef = slider;
            }}
            {...settings}
          >
            {props.state.propOverviews.propOverviews.map((item) =>
              renderList(item)
            )}
          </Slider>

          <div className="flex-center" style={{ textAlign: "center" }}>
            <Popup
              content={"Previous"}
              disabled={renderPopupState()}
              trigger={
                <span className="icon-button-gr" onClick={previous}>
                  <img
                    src="/pre.png"
                    alt=" "
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "5px",
                      verticalAlign: "middle",
                    }}
                  />
                </span>
              }
            />

            {renderPlayStopButton()}
            <Popup
              content={"Next"}
              disabled={renderPopupState()}
              trigger={
                <span className="icon-button-gr" onClick={next}>
                  <img
                    src="/next.png"
                    alt=" "
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "5px",
                      verticalAlign: "middle",
                    }}
                  />
                </span>
              }
            />
          </div>
        </div>

        {/*  */}
      </div>
      <div></div>
      {/* img modal */}
      {state.imgModalOpen && (
        <Modal
          open={state.imgModalOpen}
          onClose={handleImgModalClose}
          basic
          closeOnEscape={false}
          closeOnDimmerClick={false}
          // size='small'
        >
          <Modal.Content>
            <AddImageSingle
              hasCloseBtn={true}
              handleCloseModal={handleImgModalClose}
              id={state.id}
              path={state.path}
              handleImgModalCloseSubmit={handleImgModalCloseSubmit}
              hasDimention={false}
              height={280}
              width={425}
              folder={"ov"}
              apiRoute={`/api/PropOverviewEditForAddImagePath`}
            />
          </Modal.Content>
        </Modal>
      )}

      <Confirm
        open={state.open}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
      />
      {/* Edit Modal*/}
      {state.editModalOpen && (
        <Modal
          open={state.editModalOpen}
          onClose={handleEditModalClose}
          basic
          closeOnEscape={false}
          closeOnDimmerClick={false}
          // size='small'
        >
          <Modal.Content>
            <PropOverviewEdit
              id={state.id}
              handleEditModalCloseSubmit={handleEditModalCloseSubmit}
              handleEditModalClose={handleEditModalClose}
            />
          </Modal.Content>
        </Modal>
      )}
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    userA: state.auth.userA,
    state,
  };
};

// export default WhatWeDealsIn;
export default connect(mapStateToProps, { searchPropOverviews })(WhatWeDealsIn);
